<template>
  <div>
    <el-form :model="form" label-position="right" label-width="130px" size="mini">
      <el-form-item label="excel路径：">
        <span>{{ form.svnPath }}</span>
      </el-form-item>
      <el-form-item label="选择一个版本：">
        <el-select v-model="form.selectedExcelsCommitRevision" clearable placeholder="请先点击右侧的刷新按钮以获取可用版本集合"
          style="width: 500px">
          <el-option v-for="item in form.excelsCommitSelectorOptions" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="onClickQueryExcelsCommitListBtn()" :loading="form.isQueryingExcelsCommits"
          style="margin-left: 10px">刷新</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onClickPackExcelsBtn()">开始打包</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      // 用于定时查询excel打包结果的定时器
      timerOfQueryingExcelsPackResult: 0,

      form: {
        svnPath: "", // 当前在用的excel路径
        selectedExcelsCommitRevision: "",
        excelsCommitSelectorOptions: [],
        isQueryingExcelsCommits: false,
      },
    }
  },

  async created() {
    // 取得系统配置
    var systemConfig = {};
    {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getSystemConfig`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let systemConfigStr = resData.data.config;
      if (systemConfigStr) {
        systemConfig = JSON.parse(systemConfigStr);
      }
    }

    // 从系统配置中取得excel的svn路径
    if (systemConfig && systemConfig.dev_ops) {
      this.form.svnPath = systemConfig.dev_ops.excels_svn_path;
    }
  },

  methods: {
    /**
     * 点击了excel提交历史查询按钮
     */
    async onClickQueryExcelsCommitListBtn() {
      this.form.isQueryingExcelsCommits = true;
      this.form.excelsCommitSelectorOptions = [];
      let newOptions = [];

      let queriedCommits = await this.queryExcelsCommitList();

      for (let commit of queriedCommits) {
        let label = `${util.ms2datetime(commit.time)} | r${commit.revision} | ${commit.author} | ${commit.msg}`;

        newOptions.push({
          label: label,
          value: commit.revision,
        });
      }

      this.form.excelsCommitSelectorOptions = newOptions;

      // 自动选择第一个
      if (this.form.excelsCommitSelectorOptions.length > 0) {
        this.form.selectedExcelsCommitRevision = this.form.excelsCommitSelectorOptions[0].value;
      }

      this.form.isQueryingExcelsCommits = false;
    },

    /**
     * 查询excel提交历史
     */
    async queryExcelsCommitList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryExcelsCommitList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      return resData.data.commits;
    },

    /**
     * 点击了excel打包按钮
     */
    async onClickPackExcelsBtn() {
      if (!this.form.selectedExcelsCommitRevision) {
        this.$message.error("请先选择一个提交历史");
        return;
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/packExcels`,
          {
            revision: this.form.selectedExcelsCommitRevision,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      this.$alert("已开始打包excel，请停留几秒钟以等待打包完成...", "提示", {
        center: true,
        type: "info",
        showConfirmButton: false, // 这里特别隐藏确认按钮
        callback: (action) => {
          // 清除定时器
          clearInterval(this.timerOfQueryingExcelsPackResult);
        },
      });

      // 开始定时查询是否已经打包完成
      this.timerOfQueryingExcelsPackResult = setInterval(async () => {
        // 查询excels镜像集合
        let queriedArtifacts = await this.queryExcelsArtifactList(10);

        // 从查询到的excels镜像集合中搜索有没有针对当前打包的版本
        for (let a of queriedArtifacts) {
          let tag = ""
          let colonPos = a.artifact.lastIndexOf(":");
          if (colonPos >= 0) {
            tag = a.artifact.substr(1 + colonPos);
          }

          let selectedRevisionNumber = this.form.selectedExcelsCommitRevision;
          if (selectedRevisionNumber[0] == "r") {
            selectedRevisionNumber = selectedRevisionNumber.substring(1);
          }

          // 这里的判断兼容了tag以“111111”这个格式开头和以“r111111”这种格式开头
          if (tag.indexOf(selectedRevisionNumber) == 0 || tag.indexOf(selectedRevisionNumber) == 1) {
            // 清除定时器
            clearInterval(this.timerOfQueryingExcelsPackResult);

            // 关闭其它已经打开的MessageBox实例
            this.$msgbox.close();

            // 弹框提示
            this.$alert("excel打包已完成，关闭本弹框后将会跳转至更新页面", "提示", {
              center: true,
              type: "success",
              callback: (action) => {
                // 向父级页面请求将tab切到“更新”
                this.$emit("requestToSwitchTab", "update");
              },
            });

            break;
          }
        }
      }, 2000);
    },

    /**
     * 查询excels镜像集合
     * 
     * @param limit 让服务器返回几个（可以不填）
     */
    async queryExcelsArtifactList(limit) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryArtifactList`,
          {
            artifactType: "excels",
            limit: limit,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$alert(resData.message, "提示", {
          center: true,
          type: "error",
          callback: (action) => { },
        });

        return;
      }

      return resData.data.artifacts;
    },
  }
}
</script>